/**
 *  @class
 *  @function FaqAccordion
 */
if (!customElements.get('faq-accordion')) {
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const button = e.target.closest('[data-action="toggle-collapsible"]');
        if (!button || !this.contains(button)) return;

        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !expanded);
      });
    }
  }
  customElements.define('faq-accordion', FaqAccordion);
}
